import { Controller } from "@hotwired/stimulus";
import mapboxgl from "mapbox-gl";

export default class extends Controller {
  static values = {
    mapboxAccessToken: String,
    latitude: Number,
    longitude: Number,
  };

  initialize() {
    mapboxgl.accessToken = this.mapboxAccessTokenValue;
  }

  connect() {
    this.map = new mapboxgl.Map({
      container: this.element,
      cooperativeGestures: true,
      style: "mapbox://styles/mapbox/standard",
      center: [this.longitudeValue, this.latitudeValue], // starting position
      dragRotate: false,
      scrollZoom: true,
      zoom: 6,
    });

    const nav = new mapboxgl.NavigationControl();
    this.map.addControl(nav, "top-right");

    // Add a marker for this item
    const el = document.createElement("div");
    el.className = "map-marker";

    new mapboxgl.Marker(el).setLngLat([this.longitudeValue, this.latitudeValue]).addTo(this.map);
  }

  disconnect() {
    this.map.remove();
  }
}
